import Immutable, { Record, OrderedMap, List } from 'immutable';

import Skill from './Skills';
import Unit from './Units';
import StudentProgressTestResults from './StudentProgressTestResults';

const ProgressTestRecord = Record({
  groupId: undefined,
  progressTestId: undefined,
  progressReportId: undefined,
  courseTypeLevelCode: undefined,
  name: undefined,
  progressTestSession: undefined,
  units: new List(), // content map only
  skills: new List(),
  studentProgressTestResults: new OrderedMap(),  // key: studentId
});

class ProgressTest extends ProgressTestRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'groupId':
    case 'progressTestId':
    case 'progressReportId':
      return [key, `${val}`]; // stringify
    case 'units':
      return [key, new List(val.map(Unit.create))];
    case 'skills':
      return [key, new List(val.map(Skill.create))];
    case 'studentProgressTestResults':
      // if we've constructed this using an existing OrderedMap, keep it
      if (OrderedMap.isOrderedMap(val)) return [key, val];
      // ordering of the StudentProgressTestResults might be important
      return [key, new OrderedMap(val.map((item) => {
        const studentProgressTestResults = StudentProgressTestResults.create(item);
        return [studentProgressTestResults.studentId, studentProgressTestResults];
      }))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

ProgressTest.create = (data) =>
  new ProgressTest(data).mapEntries(reviver);

ProgressTest.serialize = (progressTest) => {
  const serializedModel = progressTest.toObject();
  const { studentProgressTestResults } = serializedModel;
  if (! StudentProgressTestResults.isSerialized(studentProgressTestResults)) {
    serializedModel.studentProgressTestResults =
        StudentProgressTestResults.serialize(studentProgressTestResults);
  }
  return serializedModel;
};

export default ProgressTest;



// WEBPACK FOOTER //
// ./data/ProgressTests/model.js